module.exports = __webpack_public_path__ + "img/67200.fda9bf3b.jpg";